<template>
    <div class=" grid gap-y-3">
        <div>
            <div class = "flex items-center">
                <p class="font-bold py-2">Country</p>
                <div class="w-full" v-if="name === 'global' || name === 'proxygo'">
                    <v-btn 
                        class="btn btn-primary btn-sm float-end"
                        :disabled="!selectedDetails.country"
                        data-bs-toggle="modal"
                        data-bs-target="#newLocationModal"
                    >
                        Request New Location
                    </v-btn>
                    <v-btn 
                        class="btn btn-primary btn-sm float-end mr-2"
                        :disabled="!(selectedDetails.country && selectedDetails.isp && selectedDetails.city)"
                        data-bs-toggle="modal"
                        data-bs-target="#newStockModal"
                    >
                        Request New Stock
                    </v-btn>
                </div>
            </div>
            <div class="overflow-hidden bg-white rounded-0 border-0 p-20">
                <div v-for="country in countryList" v-bind:key="country"
                    @click="selectCountry(country.name, country.proxy_count)" class="cursor-pointer float-left text-black"
                    rounded="0">
                    <div class=" justify-between items-center p-3">
                        <div class="relative rounded  shadow-md   hover:scale-110  duration-500  border border-black"
                            :class="selectedDetails.country === country.name ? 'scale-110 shadow-blue-500' : selectedDetails.country ? ' contrast-75' : ''">
                            <img :src="country.iconurl" class="relative rounded" width="120" height="100" />
                            <span
                                class="position-absolute z-10 start-100 text-[16px] min-w-[30px] top-0 translate-middle badge rounded-pill flex items-center justify-center aspect-square"
                                :class="(Number(country.x_proxy) + Number(country.proxysmart) + Number(country.iproxy || 0)) > 0 ? 'bg-success' : 'bg-danger'">
                                {{ (Number(country.x_proxy) + Number(country.proxysmart) + Number(country.iproxy || 0)) }}
                            </span>
                            <div
                                class="w-full flex px-2 absolute bottom-0 rounded-b border-t bg-gray text-xs py-1 font-bold z-0">
                                <div class="mx-auto px-2" style="font-size: 10px;">
                                    {{ country.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <p class="text-[10px] text-center">HTTP & SOCKS5: {{ country.x_proxy }}</p>
                    <p class="text-[10px] text-center">HTTP & SOCKS5 /W VPN: {{ country.proxysmart }}</p> -->
                </div>
            </div>
        </div>
        <div class="w-full flex flex-col lg:flex-row lg:items-center gap-2">
          <div class="text-[1rem] flex items-center py-1 px-3 bg-white gap-x-3 w-full lg:w-1/2">
              <p class="pr-4 text-[1.3rem]">Need OS / IP Fingerprint Spoofing?</p>
              <div class="flex items-center">
                  <input v-model="fingerPrint"
                      type="radio" 
                      :value="true"
                      class="cursor-pointer"
                      name="fingerprint_yes" /> 
                  <label class="cursor-pointer p-2 peer-checked:bg-blue-500 peer-checked:text-white peer-checked:border-blue-500 transition">YES</label> 
              </div>
              <div class="flex items-center">
                  <input v-model="fingerPrint" 
                      type="radio" 
                      :value="false" 
                      class="cursor-pointer"
                      name="fingerprint_no" /> 
                  <label class="cursor-pointer p-2 peer-checked:bg-blue-500 peer-checked:text-white peer-checked:border-blue-500 transition">NO</label> 
              </div>
          </div>

          <div class="text-[1rem] flex items-center py-1 px-3 bg-white gap-x-3 w-full lg:w-1/2">
              <p class="pr-4 text-[1.3rem]">Need Socks UDP?</p>
              <div class="flex items-center">
                  <input v-model="socksUdp"
                      type="radio" 
                      :value="true"
                      class="cursor-pointer"
                      name="socks_udp_yes" /> 
                  <label class="cursor-pointer p-2 peer-checked:bg-blue-500 peer-checked:text-white peer-checked:border-blue-500 transition">YES</label> 
              </div>
              <div class="flex items-center">
                  <input v-model="socksUdp" 
                      type="radio" 
                      :value="false"
                      class="cursor-pointer"
                      name="socks_udp_no" /> 
                  <label class="cursor-pointer p-2 peer-checked:bg-blue-500 peer-checked:text-white peer-checked:border-blue-500 transition">NO</label> 
              </div>
          </div>
        </div>
        <div class="flex space-x-2 pb-4">
            <div class="w-1/2">
                <p class="font-bold py-2">ISP</p>
                <div class="overflow-hidden bg-white rounded-0 border-10 p-20">

                    <div v-for="isp in ispList" v-bind:key="isp" @click="selectedISP = isp.isp"
                        class="cursor-pointer float-left box-border" rounded="0">
                        <div class=" justify-between  items-center p-3 text-black">
                            <div class="relative rounded  shadow-md w-full  hover:scale-110  duration-500  border border-black"
                                :class="selectedDetails.isp === isp.isp ? 'scale-110 shadow-blue-500' : selectedDetails.isp ? 'opacity-50 ' : ''">
                                <img :src="isp?.isp_image ? backendUrl + isp?.isp_image : 'https://webcolours.ca/wp-content/uploads/2020/10/webcolours-unknown.png'"
                                    class="relative rounded-t object-cover" style="aspect-ratio: 1/1;" width="100"
                                    height="100">
                                <span
                                    class="position-absolute top-full start-100 translate-middle badge rounded-pill flex items-center justify-center aspect-square"
                                    :class="isp.proxy_count > 0 ? 'bg-success' : 'bg-danger'">
                                    {{ isp.proxy_count }}
                                </span>
                                <div
                                    class="w-full flex justify-between px-3 bottom-0 rounded-b  z-10 bg-gray text-xs py-1 font-bold">
                                    <div class="" style="font-size: 10px;">
                                        {{ isp.isp }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="font-bold py-2">City</p>
                <div class="bg-white p-20 lg:flex gap-x-4 flex-wrap">
                    <div v-for="city in cityList" v-bind:key="city" class=" w-full py-2 lg:w-fit flex justify-center">
                        <button type="button"
                            class="btn py-1 px-4 btn-primary rounded-full text-center relative hover:scale-110"
                            @click="selectCity(city.city, city.count, city.modem_id)"
                            :class="
                                selectedDetails.city === city.city && city.count !== 0 ?
                                'scale-110 shadow-blue-500 z-10' : selectedDetails.city === city.city && city.count === 0 ? 'scale-110 opacity-50' : city.count === 0 ? ' opacity-50 z-10 ' : ''"
                            style="font-size: 10px;">
                            <p>{{ city.city }}</p>
                            <span
                                class="position-absolute top-100 start-100 translate-middle badge rounded-pill flex items-center justify-center aspect-square z-10"
                                :class="city.count > 0 ? 'bg-success' : 'bg-danger'">
                                {{ city.count }}
                            </span>
                        </button>

                    </div>
                </div>
            </div>
            <div class="w-1/2">
                <p class="font-bold py-2">Package</p>
                <div class="bg-white p-10"
                    v-if="selectedDetails.country && selectedDetails.isp && selectedDetails.city && selectedDetails.modems_id.length > 0">
                    <div class="md:flex justify-center">
                        <div v-if="plans.hourly !== null"
                            class="sm:w-1/2 lg:w-52  mx-auto p-3 hover:scale-110 cursor-pointer duration-500  "
                            :class="selectedPlan === 'hourly' ? 'scale-110' : ''" @click="selectedPlan = 'hourly'">
                            <div class="card">
                                <img :src="ispList.find(isp => isp.isp === selectedDetails.isp) && ispList.find(isp => isp.isp === selectedDetails.isp)?.isp_image ?
                                    backendUrl + ispList.find(isp => isp.isp === selectedDetails.isp).isp_image :
                                    `https://webcolours.ca/wp-content/uploads/2020/10/webcolours-unknown.png`"
                                    class="w-full aspect-square object-cover brightness-50 rounded-md  " />
                                <div class="absolute w-full h-full top-0 text-black border border-black shadow-md
                                 rounded-md duration-500  bg-package-card  flex items-center justify-center font-bold"
                                    :class="selectedPlan === 'hourly' ? 'shadow-blue-500' : ''">
                                    <div class="text-xs xl:text-[14px] 2xl:text-[16px]" style="line-height: normal;">
                                        <!-- <p class="text-center">{{ plans.hourly.name }}</p> -->
                                        <p class="text-center">${{ plans.hourly.price }} : Hourly</p>
                                        <p class="text-center">{{ selectedDetails.country }} {{ selectedDetails.city }}</p>
                                        <p class="text-center" v-if="plans.hourly?.data_limit">Max Data per Day: {{ plans.hourly.data_limit }}GB</p>
                                        <p class="text-center" v-if="plans.hourly?.rotation_time">Minimum IP Rotation Time: {{ plans.hourly.rotation_time }}mins</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="plans.daily !== null"
                            class="sm:w-1/2 lg:w-52  mx-auto p-3 hover:scale-110 cursor-pointer duration-500  "
                            :class="selectedPlan === 'daily' ? 'scale-110' : ''" @click="selectedPlan = 'daily'">
                            <div class="card">
                                <img :src="ispList.find(isp => isp.isp === selectedDetails.isp) && ispList.find(isp => isp.isp === selectedDetails.isp)?.isp_image ?
                                    backendUrl + ispList.find(isp => isp.isp === selectedDetails.isp).isp_image :
                                    `https://webcolours.ca/wp-content/uploads/2020/10/webcolours-unknown.png`"
                                    class="w-full aspect-square object-cover brightness-50 rounded-md  " />
                                <div class="absolute w-full h-full top-0 text-black border border-black shadow-md
                                 rounded-md duration-500  bg-package-card  flex items-center justify-center font-bold"
                                    :class="selectedPlan === 'daily' ? 'shadow-blue-500' : ''">
                                    <div class="text-xs xl:text-[14px] 2xl:text-[16px]" style="line-height: normal;">
                                        <!-- <p class="text-center">{{ plans.daily.name }}</p> -->
                                        <p class="text-center">${{ plans.daily.price }} : Daily</p>
                                        <p class="text-center">{{ selectedDetails.country }} {{ selectedDetails.city }}</p>
                                        <p class="text-center" v-if="plans.daily?.data_limit">Max Data per Day: {{ plans.daily.data_limit }}GB</p>
                                        <p class="text-center" v-if="plans.daily?.rotation_time">Minimum IP Rotation Time: {{ plans.daily.rotation_time }}mins</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="plans.weekly !== null"
                            class="sm:w-1/2 lg:w-52  mx-auto p-3 hover:scale-110 cursor-pointer duration-500  "
                            :class="selectedPlan === 'weekly' ? 'scale-110' : ''" @click="selectedPlan = 'weekly'">
                            <div class="card flex ">
                                <img :src="ispList.find(isp => isp.isp === selectedDetails.isp)?.isp_image ?
                                    backendUrl + ispList.find(isp => isp.isp === selectedDetails.isp)?.isp_image :
                                    `https://webcolours.ca/wp-content/uploads/2020/10/webcolours-unknown.png`"
                                    class="w-full aspect-square object-cover brightness-50 rounded-md  " />
                                <div class="absolute w-full h-full top-0 text-black border border-black shadow-md
                                 rounded-md duration-500  bg-package-card  flex items-center justify-center font-bold"
                                    :class="selectedPlan === 'weekly' ? 'shadow-blue-500' : ''">
                                    <div class="text-xs xl:text-[14px] 2xl:text-[16px]" style="line-height: normal;">
                                        <!-- <p class="text-center">{{ plans.weekly.name }}</p> -->
                                        <p class="text-center">${{ plans.weekly.price }} : Weekly</p>
                                        <p class="text-center">{{ selectedDetails.country }} {{ selectedDetails.city }}</p>
                                        <p class="text-center" v-if="plans.weekly?.data_limit">Max Data per Day: {{ plans.weekly.data_limit }}GB</p>
                                        <p class="text-center" v-if="plans.weekly?.rotation_time">Minimum IP Rotation Time: {{ plans.weekly.rotation_time }}mins</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="plans.monthly !== null"
                            class="sm:w-1/2 lg:w-52  mx-auto p-3 hover:scale-110 cursor-pointer duration-500  "
                            :class="selectedPlan === 'monthly' ? 'scale-110' : ''" @click="selectedPlan = 'monthly'">
                            <div class="card">
                                <img :src="ispList.find(isp => isp.isp === selectedDetails.isp)?.isp_image ?
                                    backendUrl + ispList.find(isp => isp.isp === selectedDetails.isp)?.isp_image :
                                    `https://webcolours.ca/wp-content/uploads/2020/10/webcolours-unknown.png`"
                                    class="w-full aspect-square object-cover brightness-50 rounded-md  " />
                                <div class="absolute w-full h-full top-0 text-black border border-black shadow-md
                                 rounded-md duration-500  bg-package-card  flex items-center justify-center font-bold"
                                    :class="selectedPlan === 'monthly' ? 'shadow-blue-500' : ''">
                                    <div class="text-xs xl:text-[14px] 2xl:text-[16px]" style="line-height: normal;">
                                        <!-- <p class="text-center">{{ plans.monthly.name }}</p> -->
                                        <p class="text-center">${{ plans.monthly.price }} : Monthly</p>
                                        <p class="text-center">{{ selectedDetails.country }} {{ selectedDetails.city }}</p>
                                        <p class="text-center" v-if="plans.monthly?.data_limit">Max Data per Day: {{ plans.monthly.data_limit }}GB</p>
                                        <p class="text-center" v-if="plans.monthly?.rotation_time">Minimum IP Rotation Time: {{ plans.monthly.rotation_time }}mins</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="w-full flex justify-center mt-4">
                        <button id="purchaseBtn" type="button" class="btn btn-primary w-1/2 mt-4"
                            :disabled="!(selectedDetails.country && selectedDetails.isp && selectedDetails.city && selectedPlan)"
                            data-bs-toggle="modal" data-bs-target="#purchaseModal">Purchase</button>
                    </div>
                </div>

            </div>
        </div>

    </div>
    <div>
        <PurchaseModal :selected-details="selectedDetails" :plan="selectedPlan && plans[selectedPlan]" :openVPN="openVPNTemp" />
        <NewLocationModal :selected-details="selectedDetails" />
        <NewStockModal :selected-details="selectedDetails" />
    </div>
</template>

<script setup>

import { ref, watch, onMounted, nextTick } from "vue";
import { usePackageStore, useAdminConfigurationStore } from "@/stores"
import { watchEffect } from "vue";
import { storeToRefs } from "pinia";
import PurchaseModal from "@/components/Customer/BuyNewProxy/PurchaseModal.vue"
import NewLocationModal from "@/components/Customer/BuyNewProxy/NewLocationModal.vue"
import NewStockModal from "@/components/Customer/BuyNewProxy/NewStockModal.vue"
const name = process.env.VUE_APP_VUE_NAME;
const backendUrl = process.env.VUE_APP_VUE_SOCKET_URL + "/";
const selectedDetails = ref({ country: null, isp: null, city: null, modems_id: [] });
const adminConfigurationStore = useAdminConfigurationStore();
const packageStore = usePackageStore();
const { countryList, plans } = storeToRefs(packageStore);
const ispList = ref([]);
const cityList = ref([]);
const openVPNTemp = true;

const selectedISP = ref(null)
const selectedPlan = ref(null)

const fingerPrint = ref(false);
const socksUdp = ref(false);
// No serverType filtering: always merge across XProxy + ProxySmart + IPROXY

/** Strip modem_id when count is 0 (XProxy base and merged rows). */
const normalizeCityModems = (cities) =>
    (cities || []).map((c) => ({
        ...c,
        modem_id: Number(c.count) > 0 && Array.isArray(c.modem_id) ? [...c.modem_id] : [],
    }));

const fingerPrintClick = (val) => {
    fingerPrint.value = val;
}

const socksUdpClick = (val) => {
    socksUdp.value = val;
}

watchEffect(async () => {
    await adminConfigurationStore.getOpenvpn()
})

const { openvpn } = storeToRefs(adminConfigurationStore)

// No separate IPROXY option for No VPN; IPROXY will be merged into XProxy

const selectCountry = (countryName, proxy_count) => {
    // if (proxy_count > 0)
    if (selectedDetails.value.country === countryName) {
        selectedDetails.value.country = null
    }
    else {
        selectedDetails.value.country = countryName
    }
}

const selectCity = (cityName, proxy_count, modem_id) => {
    // if (proxy_count > 0)
    selectedDetails.value.city = cityName;
    selectedDetails.value.modems_id = modem_id;
}

onMounted(async () => {
    await packageStore.getCountryList(fingerPrint.value, socksUdp.value)
    selectedDetails.value.country = countryList.value[0]?.name
});
watchEffect(async () => {
    if (countryList.value?.length === 0){
        await packageStore.getCountryList(fingerPrint.value, socksUdp.value)
        // countryList.value[1] = countryList.value[0];
        // countryList.value[0] = temp;
        // [countryList.value[0], countryList.value[1]] = [countryList.value[1], countryList.value[0]]
        selectedDetails.value.country = countryList.value[0]?.name
    }

}, [countryList.value])
watch(
    () => selectedDetails.value.country,
    async (newCountry, oldCountry) => {
        if (newCountry) {
            // Always merge ISP lists across XProxy, ProxySmart, IPROXY (filtered by flags)
            const xproxyISP = await packageStore.getISPList(newCountry, 'XProxy', fingerPrint.value, socksUdp.value);
            const iproxyISP = await packageStore.getISPList(newCountry, 'IPROXY', fingerPrint.value, socksUdp.value);
            const proxysmartISP = await packageStore.getISPList(newCountry, 'ProxySmart', fingerPrint.value, socksUdp.value);

            const ispMap = new Map();
            const addISPList = (list) => {
                list?.forEach((item) => {
                    if (!item || !item.isp) return;
                    const key = item.isp;
                    const existing = ispMap.get(key) || {
                        isp: key,
                        proxy_count: 0,
                        isp_image: item.isp_image
                    };
                    existing.proxy_count += Number(item.proxy_count || 0);
                    if (!existing.isp_image && item.isp_image) {
                        existing.isp_image = item.isp_image;
                    }
                    ispMap.set(key, existing);
                });
            };
            addISPList(xproxyISP);
            addISPList(iproxyISP);
            addISPList(proxysmartISP);
            let ispListTemp = Array.from(ispMap.values());
            ispList.value = ispListTemp || [];

            if (ispList.value && ispList.value?.length > 0) {
                selectedDetails.value.isp = ispList.value[0].isp;
                selectedISP.value = ispList.value[0].isp;
            } else {
                selectedDetails.value.isp = null;
                selectedISP.value = null;
            }
        } else {
            ispList.value = [];
            cityList.value = [];
        }
    },
    { immediate: true }
);

watchEffect(async () => {
    if (selectedISP.value) {
        const tempISP = selectedISP.value
        selectedDetails.value.isp = tempISP
        if (selectedDetails.value.country && tempISP) {
            // Always merge cities from XProxy, ProxySmart, and IPROXY (filtered by flags)
            const baseCity = await packageStore.getCityList(selectedDetails.value.country, tempISP, "XProxy", fingerPrint.value, socksUdp.value);
            cityList.value = normalizeCityModems(baseCity);

            const mergeTypes = ["IPROXY", "ProxySmart"];
            for (const type of mergeTypes) {
                const extraCity = await packageStore.getCityList(selectedDetails.value.country, tempISP, type, fingerPrint.value, socksUdp.value);
                const len = cityList.value?.length;
                extraCity?.map(city => {
                    if (len !== 0) {
                        let flag = 0;
                        for (let i = 0; i < cityList.value.length; i++) {
                            if (cityList.value[i].city.trim() === city.city.trim()) {
                                flag = 1;
                                if (Number(city.count) > 0) {
                                    cityList.value[i].count = Number(cityList.value[i].count) + Number(city.count);
                                    city?.modem_id?.forEach((id) => {
                                        cityList.value[i].modem_id.push(id);
                                    });
                                }
                            }
                        }
                        if (flag === 0) {
                            cityList.value.push(city);
                        }
                    }
                    else {
                        cityList.value.push(city)
                    }
                });
            }
            cityList.value = normalizeCityModems(cityList.value);
            if (cityList.value && cityList.value?.length > 0){
                selectedDetails.value.city = cityList.value[0].city;
                selectedDetails.value.modems_id = cityList.value[0].modem_id
            }
            else {
                selectedDetails.value.city = null
            }
        }
    }
}, [selectedISP.value])

watch(
    () => [fingerPrint.value, socksUdp.value],
    async () => {
        const prevCountry = selectedDetails.value.country

        // Reload country list using current flags
        await packageStore.getCountryList(fingerPrint.value, socksUdp.value)

        // Reset dependent selections
        ispList.value = []
        cityList.value = []
        selectedISP.value = null
        selectedPlan.value = null
        selectedDetails.value.isp = null
        selectedDetails.value.city = null
        selectedDetails.value.modems_id = []

        // Keep previous country if still available; otherwise pick first
        const nextCountry =
            countryList.value?.find(c => c?.name === prevCountry)?.name ||
            countryList.value?.[0]?.name ||
            null

        // Force re-trigger of the country watcher even if the country name didn't change
        selectedDetails.value.country = null
        await nextTick()
        selectedDetails.value.country = nextCountry
    }
)

watchEffect(() => {
    if (selectedDetails.value.country && selectedDetails.value.isp && selectedDetails.value.city && selectedDetails.value.modems_id.length > 0) {
        // emit("detailChoosed", selectedDetails.value)
        packageStore.getPlans(selectedDetails.value.country, selectedDetails.value.isp, selectedDetails.value.city, selectedDetails.value.modems_id).then((res) => {
            if (res){
                selectedPlan.value = Object.keys(res).filter(key => res[key] !== null)[0]
            }
        })
    }
}, [selectedDetails.value.city])


</script>